import { render, staticRenderFns } from "./SearchResponsesItem.vue?vue&type=template&id=2a314c11&scoped=true"
import script from "./SearchResponsesItem.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItem.vue?vue&type=style&index=0&id=2a314c11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a314c11",
  null
  
)

export default component.exports